export default __webpack_public_path__ + "static/media/namelogo.46f13354.svg";